module.exports = {
      id: "ic-arrow-green-usage",
      viewBox: "0 0 22 31",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-arrow-green-usage",
      toString: function () {
        return this.url;
      }
    }